<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15ttoIy/tc-custom/9781459241411.jpg?1708752100458" alt="This image is the cover for the book Not Just the Greek's Wife"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Not Just the Greek's Wife
      </h1>
      <p class="bookDescription body article font2">
        <b>Seeking to produce an heir to his empire, a man gets more than he bargained for in <i>USA Today</i>–bestselling author Lucy Monroe’s <i>Not Just the Greek’s Wife</i>.</b><br/><br/>Ariston Spiridakou had one reason and one reason only for marrying Chloe: he needed a biddable bride to provide the requisite heir. Yet three years later Chloe’s status as good Greek wife is a distant memory—and her defiance has had her cast out of Ariston’s life.<br/><br/>Infuriatingly, Chloe now finds herself at Ariston’s mercy—but his help comes with a wicked price: the unyielding condition that he won’t even consider her request until she’s shared his bed—and is expecting his baby!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lucy  Monroe
      </h2>
      
      <p class="authorDescription body article">USA Today Bestseller Lucy Monroe finds inspiration for her stories everywhere as she is an avid people-watcher. She has published more than fifty books in several subgenres of romance and when she&#39;s not writing, Lucy likes to read. &#160;She&#39;s an unashamed book geek, but loves movies and the theatre too. She adores her family and truly enjoys hearing from her readers! Visit her website at: http://lucymonroe.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6052f8bd